const f = {
  color: {
    default: "#405261ff",
    error: "#b83525ff",
    success: "#222923ff",
    warning: "#a35214ff",
    light: "#556575ff",
    subtle: "#405261ff",
    slightlyMuted: "#556575ff",
    muted: "#556575ff",
    faint: "#7e8e9eff",
    extraMuted: "#abb9c7ff",
    link: "#304ddbff"
  }
};
export {
  f as text
};
